import gql from 'graphql-tag'

import { famIngredient } from './Ingredient'

export const famIngredientRecipe = gql`
  fragment famIngredientRecipe on Ingredient {
    ...famIngredient
    ingredient_recipe {
      quantity
      measurement_unit {
        name
        plural
        use_ingredient_name
        round_type
      }
      gross_weight
    }
  }
  ${famIngredient}
`
